var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWgc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E60082"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4141 13.75H15.625H14.2109H13.75V14.0938V15.625V17.2031V20.6797L10.0078 17.9102C10.0703 17.2031 10.4336 16.5469 11.0117 16.1211L11.875 15.4805V13.75C11.875 12.7148 12.7148 11.875 13.75 11.875H16.7422L18.6914 10.4336C19.0703 10.1523 19.5273 10 20 10C20.4727 10 20.9297 10.1523 21.3086 10.4297L23.2578 11.875H26.25C27.2852 11.875 28.125 12.7148 28.125 13.75V15.4805L28.9883 16.1211C29.5664 16.5469 29.9297 17.2031 29.9922 17.9102L26.25 20.6797V17.2031V15.625V14.0938V13.75H25.7891H24.375H21.5859H18.4102H18.4141ZM10 27.5V19.457L18.5 25.7539C18.9336 26.0742 19.4609 26.25 20 26.25C20.5391 26.25 21.0664 26.0781 21.5 25.7539L30 19.457V27.5C30 28.8789 28.8789 30 27.5 30H12.5C11.1211 30 10 28.8789 10 27.5ZM16.875 16.25H23.125C23.4688 16.25 23.75 16.5312 23.75 16.875C23.75 17.2188 23.4688 17.5 23.125 17.5H16.875C16.5312 17.5 16.25 17.2188 16.25 16.875C16.25 16.5312 16.5312 16.25 16.875 16.25ZM16.875 18.75H23.125C23.4688 18.75 23.75 19.0312 23.75 19.375C23.75 19.7188 23.4688 20 23.125 20H16.875C16.5312 20 16.25 19.7188 16.25 19.375C16.25 19.0312 16.5312 18.75 16.875 18.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWgc);
export default __webpack_public_path__ + "static/media/wgc.780e6f633566ec7b0a1eff8d41d3e09a.svg";
export { ForwardRef as ReactComponent };